import { type RouteRecordRaw } from 'vue-router'

import Layout from '@/layout/index.vue'

/**
 * Alert Engine module routes.
 *
 * The module is intentionally isolated from the legacy Watcher system —
 * no shared components, no shared state, no shared routes.
 *
 * Layout: /alerts is a parent view with top tabs (Dashboard / Pravidlá / Údržbové
 * okná / Eskalácie). Detail screens (rule editor, instance detail) are sibling
 * routes without the tabs bar.
 *
 * Phase 1 (current): UI-only with mock data, no backend wiring.
 */
export const alertRoutes: RouteRecordRaw[] = [
  {
    path: '/alerts',
    component: () => import('@/modules/module-alerts/views/index.vue'),
    name: 'Alerts',
    meta: { hidden: true, layout: Layout },
    redirect: '/alerts/rules',
    children: [
      {
        path: 'rules',
        name: 'AlertsRules',
        component: () => import('@/modules/module-alerts/views/rules/index.vue'),
        meta: { title: 'alerts.tabs.rules' },
      },
      {
        path: 'suppressions',
        name: 'AlertsSuppressions',
        component: () => import('@/modules/module-alerts/views/suppressions/index.vue'),
        meta: { title: 'alerts.tabs.suppressions' },
      },
    ],
  },
  {
    path: '/alerts/rules/new',
    name: 'AlertsRuleNew',
    component: () => import('@/modules/module-alerts/views/rules/edit.vue'),
    meta: { hidden: true, layout: Layout },
  },
  {
    path: '/alerts/rules/:id/edit',
    name: 'AlertsRuleEdit',
    component: () => import('@/modules/module-alerts/views/rules/edit.vue'),
    meta: { hidden: true, layout: Layout },
  },
  {
    path: '/alerts/rules/:id/instances',
    name: 'AlertsRuleInstances',
    component: () => import('@/modules/module-alerts/views/rules/instances.vue'),
    meta: { hidden: true, layout: Layout },
  },
  {
    path: '/alerts/instances/:id',
    name: 'AlertsInstanceDetail',
    component: () => import('@/modules/module-alerts/views/instances/detail.vue'),
    meta: { hidden: true, layout: Layout },
  },
]
